module.exports = __webpack_public_path__ + "img/dp158_10.66880d18.jpg";